var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTextMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4D7BFD",
    fillOpacity: 0.05,
    d: "M42.5 85C65.972 85 85 65.972 85 42.5S65.972 0 42.5 0 0 19.028 0 42.5 19.028 85 42.5 85z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0000FF",
    strokeMiterlimit: 20,
    strokeWidth: 2,
    d: "M5 36c0-5.523 4.477-10 10-10h55c5.523 0 10 4.477 10 10v5.32c0 5.522-4.477 10-10 10H41.842v0L35.347 59v0l-5.982-7.68v0H15c-5.523 0-10-4.478-10-10z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0000FF",
    d: "M14.5 41.233L17.899 43l-.902-3.33L20 37.43l-3.954-.29L14.5 34l-1.546 3.14L9 37.43l3.003 2.24-.902 3.33z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0000FF",
    d: "M50 41.233L53.09 43l-.82-3.33L55 37.43l-3.595-.29L50 34l-1.405 3.14-3.595.29 2.73 2.24-.82 3.33z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0000FF",
    d: "M25 41.233L28.09 43l-.82-3.33L30 37.43l-3.595-.29L25 34l-1.405 3.14-3.595.29 2.73 2.24-.82 3.33z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0000FF",
    d: "M60.5 41.233L63.899 43l-.902-3.33L66 37.43l-3.954-.29L60.5 34l-1.546 3.14-3.954.29 3.003 2.24-.902 3.33z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0000FF",
    d: "M71.5 41.233L74.899 43l-.902-3.33L77 37.43l-3.954-.29L71.5 34l-1.546 3.14-3.954.29 3.003 2.24-.902 3.33z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0000FF",
    d: "M35 41.233L38.09 43l-.82-3.33L40 37.43l-3.595-.29L35 34l-1.405 3.14-3.595.29 2.73 2.24-.82 3.33z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.36
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0000FF",
    d: "M42.5 66C57.136 66 69 64.88 69 63.5S57.136 61 42.5 61 16 62.12 16 63.5 27.864 66 42.5 66z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextMessage);
export default __webpack_public_path__ + "static/media/TextMessage.7e72da3d990962e6f48cae88b14763a6.svg";
export { ForwardRef as ReactComponent };